// 法人情報削除
import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import { Button } from 'react-bootstrap';
import axios from '../../../axios';
import { handleBrowserBack } from '../../../BrowserBack';
import { isBrowserIe } from '../../../BrowserJudgment';
import { api_response_type } from '../../../Const';
import { ResponseDetailType, CorporateRequestType, ValidMessageType } from '../../../types/Corporate';
import { CorporateLabelData } from '../../../const/Corporate';
import PopupStaff from '../../../molecules/PopupStaff';
import LoadingModal from '../../../molecules/LoadingModal';
import CorporateInfoConfirm from '../../../organisms/CorporateInfoConfirm';
import CorporateCreateEditComment from '../../../organisms/CorporateCreateEditComment';
import { KWMNTGM05030A01, KWMNTGM05050A02, KWMNTGM05090A02 } from '../../../const/api_modules';
import { CorporationInfoFormatValue } from '../../../Common';

const CorporateInfoDelete = () => {
  const [data, setData] = useState<ResponseDetailType | undefined>(undefined);
  const [verified_data, setVerifiedData] = useState<ResponseDetailType | undefined>(undefined);
  const [edit_comment, setEditComment] = useState('');
  // エラーメッセージ
  const [valid_message, setValidMessage] = useState<ValidMessageType[]>([]);
  // 確認画面を表示するフラグ
  const [is_confirm, setIsConfirm] = useState(false);
  // ポップアップの表示制御
  const [is_popup, setIsPopup] = useState(false);
  const [is_loading, setIsLoading] = useState(false);
  // 相関チェックのエラーメッセージ
  const [error_message, setErrorMessage] = useState('');

  // URLパラメータの取得
  const url_params = new URLSearchParams(document.location.search.substring(1));
  const corporate_id = url_params.get('corporate_id');

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
    // 初期値のデータを取得
    getData();
  }, []);

  useEffect(() => {
    if (valid_message.findIndex(value => value.form_name === 'temp_comment') === -1 && valid_message.length > 0) {
      alert(valid_message[0].message);
    }
  }, [valid_message]);

  // 初期値のデータを取得
  const getData = async () => {
    setIsLoading(true);
    try {
      const detail = [{ id: 0, name: 'id', value: corporate_id }];

      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/common`, {
        module_name : KWMNTGM05030A01,
        is_json : true,
        reception_id : '0',
        reception_cd : null,
        detail : detail,
      });

      if (response.data.result) {
        // 取得したデータをstateにセット
        setData(response.data.detail);
      }
    } catch (error) {
      console.error(error.response.data.message);
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * 【削除】ボタン押下時の処理
   */
  const handleDelete = async () => {
    try {
      // ローディング画面表示
      setIsLoading(true);
      // エラー初期化
      setErrorMessage('');
      setValidMessage([]);

      let detail: CorporateRequestType[] = [];
      const info = data?.corporate_information;
      if (info) {
        detail = [
          { id: 0, name: 'id', value: info.id },
          { id: 0, name: 'temp_corporate_name', value: info.temp_corporate_name },
          { id: 0, name: 'temp_corporate_kana_name', value: info.temp_corporate_kana_name },
          { id: 0, name: 'temp_address', value: info.temp_address },
          { id: 0, name: 'temp_comment', value: edit_comment },
        ];
      }

      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/common`, {
        module_name : KWMNTGM05090A02,
        is_json : true,
        reception_id : '0',
        reception_cd : null,
        detail : detail,
      });

      // APIからの応答種別を判定（相関チェック）
      if (response.data.response_type === api_response_type.error) {
        //モーダルでメッセージを表示
        setErrorMessage(response.data.message);
        setIsPopup(true);
      } else if (response.data.response_type === api_response_type.validation) {
        setValidMessage(response.data.detail);
      } else if (
        response.data.response_type === api_response_type.transition_to_corporate_entry_confirm
      ) {
        // データをセットして確認画面を表示
        setVerifiedData(response.data.detail);
        setIsConfirm(true);
      }
    } catch (error) {
      console.error(error.response.data.message);
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * 【確認】ボタン押下時の処理
   */
  const handleConfirm = async () => {
    try {
      // ローディング画面表示
      setIsLoading(true);

      let detail: CorporateRequestType[] = [];
      const info = verified_data?.corporate_information;
      if (info) {
        detail = [
          { id: 0, name: 'id', value: info.id },
          { id: 0, name: 'temp_corporate_name', value: info.temp_corporate_name },
          { id: 0, name: 'temp_corporate_kana_name', value: info.temp_corporate_kana_name },
          { id: 0, name: 'temp_address', value: info.temp_address },
          { id: 0, name: 'temp_comment', value: info.temp_comment },
        ];
      }

      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/common`, {
        module_name : KWMNTGM05050A02,
        is_json : true,
        reception_id : '0',
        reception_cd : null,
        detail : detail,
      });

      // APIからの応答種別を判定
      if (response.data.response_type === api_response_type.navigation_finish) {
        // 完了画面に遷移
        location.replace(
          `${location.origin}${process.env.MIX_MOCK_URL}/staff/corporate_info_edit_complete`
        );
      }
    } catch (error) {
      console.error(error.response.data.message);
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * 【キャンセル】ボタン押下時の処理
   */
  const backTransition = () => {
    if (isBrowserIe()) {
      const node = document.getElementById('corporate-info-delete');
      location.replace(node?.dataset.referer as string);
    } else {
      location.replace(document.referrer);
    }
  };

  return (
    <div className="corporate">
      <div className="title">法人情報</div>
      <div className="container">
        <div className="contents">
          {!is_confirm ? (
            <>
              <p className="contents_title mb-5">法人情報削除</p>
              <div className="group_wrapper">
                {Object.entries(CorporateLabelData).map(([key, value]) => (
                  <dl className="field_section" key={key}>
                    <dt className="field_label">{value}</dt>
                    <dd className="field_data">{CorporationInfoFormatValue(data?.corporate_information[key], key)}</dd>
                  </dl>
                ))}
                <CorporateCreateEditComment
                  margin="mt-4"
                  edit_comment={edit_comment}
                  setEditComment={setEditComment}
                  valid_message={valid_message}
                />
              </div>
              <div className="w_button_section mx-auto my-5 d-flex justify-content-between">
                <Button
                  className="btn-mini btn-text-color"
                  variant="outline-success"
                  onClick={backTransition}
                >
                  キャンセル
                </Button>
                <Button className="btn-mini btn-danger" onClick={handleDelete}>
                  削除
                </Button>
              </div>
            </>
          ) : (
            <CorporateInfoConfirm
              verified_data={verified_data}
              setIsConfirm={setIsConfirm}
              handleConfirm={handleConfirm}
            />
          )}
        </div>
      </div>
      <PopupStaff
        toggleShow={is_popup}
        text={error_message}
        btn1_label={'OK'}
        btn1_css={'btn-danger'}
        btn1_func={() => setIsPopup(false)}
      />
      <LoadingModal show={is_loading} />
    </div>
  );
};

if (document.getElementById('corporate-info-delete')) {
  render(<CorporateInfoDelete />, document.getElementById('corporate-info-delete'));
}
